import SmoothScroll from 'smooth-scroll';
import '../modules/docout';

$('.js-docout').each(function() {
  const dom = $(this)

  dom.hide();

  $(dom.data('body')).docout({
    target: dom.data('target'),
    elements: [ 'h2', 'h3' ],
    rootClass: 'article__outline__list',
    childClass: 'article__outline__item'
  })

  const firstHeading = $(dom.data('body')).find('h2, h3').first();
  firstHeading.before(dom.children().first().remove());

  dom.remove();

  new SmoothScroll('a[href*="#"]', {
    header: '#main-header',
    speed: 800,
    speedAsDuration: true
  })
});